import React, { useRef, useEffect, useState } from "react";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { observerAddToHandles } from "../../../handles/Handles";
import CircleBlack from "../../../assets/CircleBlack";
import CircleHalfFilled from "../../../assets/CircleHalfFilled";
import OpacityButton from "../../../assets/OpacityButton/OpacityButton";
import { Slider, Stack } from "@mui/material";

const BasemapOpacityWidget = ({
  view,
  mapId,
  mapEmbed = true,
  position = "top-left",
}) => {
  const basemapOpacityWidgetDiv = useRef(null);
  const basemapOpacitySlider = useRef(null);
  const [basemapOpacity, setbasemapOpacity] = useState(100);

  useEffect(() => {
    if (basemapOpacityWidgetDiv.current) {
      view.map.when(() => {
        if (mapEmbed) {
          view.ui.add(basemapOpacityWidgetDiv.current, position);
        }
        let baseLayer = view.map.basemap.baseLayers.getItemAt(0);
        if (!baseLayer.hasOwnProperty("opacity")) {
          return;
        }
        if (!localStorage.hasOwnProperty(`baseLayersOpacity-${mapId}`)) {
          return;
        }
        let basemapOpacity = Math.round(
          Number(JSON.parse(localStorage.getItem(`baseLayersOpacity-${mapId}`)))
        );
        setbasemapOpacity(basemapOpacity);
      });
    }
  }, []);

  useEffect(() => {
    if (basemapOpacityWidgetDiv.current) {
      //view.when((view)=>{
      updateBasemapOpacity(view, basemapOpacity);
      observerAddToHandles(
        reactiveUtils.watch(
          () => view?.map?.basemap?.title,
          (e) => {
            updateBasemapOpacity(view, basemapOpacity);
          }
        ),
        `basemapOpacityHandle`
      );
      //})
    }
  }, [basemapOpacity]);

  return (
    <>
      <div
        ref={basemapOpacityWidgetDiv}
        id="opacitySliderDiv"
        title="Basemap opacity"

      ><Stack direction="row"  spacing={0} sx={{backgroundColor:"white", borderRadius:"20%"}}>
        <OpacityButton
            onClick={() => {
              const opacitySlider = basemapOpacitySlider.current;
              opacitySlider.style.display =
                opacitySlider.style.display === "none" ? "inline" : "none";
            }}
          />
        <Stack direction="row" spacing={2} sx={{borderRadius:"0%", backgroundColor:"white"}}>

          <div style={{ display: "none" }} ref={basemapOpacitySlider}>
            <span style={{ paddingRight: "2px", verticalAlign: "40%" }}>
              <CircleHalfFilled />
            </span>
            <Slider
              sx={{
                width: 160,
                marginLeft: 2,
                marginRight: 2,
              }}
              min={0}
              max={100}
              onChange={(event: any) => {
                setbasemapOpacity(Number(event.target.value));
                localStorage.setItem(
                  `baseLayersOpacity-${mapId}`,
                  event.target.value
                );
              }}
              value={basemapOpacity}
            />
            <span style={{ paddingRight: "2px", verticalAlign: "40%" }}>
              <CircleBlack />
            </span>
            <span
              style={{
                paddingLeft: "2px",
                paddingRight: "2px",
                verticalAlign: "50%",
              }}
            >
              {basemapOpacity}%
            </span>
          </div>
        </Stack>
        </Stack>
      </div>
    </>
  );
};

const updateBasemapOpacity = (view, basemapOpacity) => {
  for (let i = 0; i < view?.map?.basemap?.baseLayers?.length; i++) {
    view.map.basemap.baseLayers.getItemAt(i).opacity = basemapOpacity / 100;
  }
};

export default BasemapOpacityWidget;
